<template>
  <div>
    <Flex v-bind:style="sidePanelStyle" grow class="sidebar">
      <MapFilter
        :options="mapElementIds"
        :showPinsOnload="showPinsOnload"
        :components="components"
        :poiTypes="poiTypes"
        :availableHeight="availableHeight"
        :loading="loading"
        @mapFilterEvent="emitEvent"
      >
      </MapFilter>
    </Flex>
    <div class="iconContainer" v-bind:style="iconPanelStyle">
      <IconButton :src="icon" size="xl" color="gray" @click="showHideSideBar" />
    </div>
  </div>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex'
import IconButton from '@wizer/core/components/icon-button/IconButton'
import MapFilter from './MapFilter'

export default {
  /**
   * Name of the component
   */
  name: 'MapSideBar',

  /**
   * Components
   */
  components: {
    IconButton,
    MapFilter,
    Flex,
  },

  /**
   * This components properties
   */
  props: [
    'mapElementIds',
    'expandedWidth',
    'components',
    'showFilterPanel',
    'availableHeight',
    'loading',
    'poiTypes',
  ],

  /**
   * This components data attributes
   */
  data() {
    return {
      isExpanded: this.showFilterPanel === 'true',
    }
  },

  /**
   * Computed properties
   */
  computed: {
    sidePanelStyle() {
      return {
        width: this.isExpanded ? this.expandedWidth : '5px',
      }
    },
    iconPanelStyle() {
      return {
        marginLeft: this.isExpanded ? `${parseInt(this.expandedWidth, 10) - 5}px` : '0px',
      }
    },
    icon() {
      return this.isExpanded ? 'material/chevron_left' : 'material/chevron_right'
    },
    showPinsOnload() {
      return !(this.showFilterPanel === 'true')
    },
  },

  /**
   * Component methods
   */
  methods: {
    /**
     * Emits a side bar event
     * @param event received event
     */
    emitEvent(event) {
      this.$emit('event', event)
    },
    /**
     * Toggles the side bar and emits a side bar expansion event
     */
    showHideSideBar() {
      this.isExpanded = !this.isExpanded
      this.$emit('expanded', this.isExpanded)
    },
  },
}
</script>
<style lang="postcss" scoped>
.dashboardSideBarIcon {
  @apply z-20 w-20;
}
.iconContainer {
  @apply fixed left-0 z-10;
  top: 50%;
  transform: translateY(-50%);
  transition: 0.5s;
}
.sidebar {
  @apply h-full w-0 fixed z-10 top-0 left-0 bg-gray-100 overflow-x-hidden overflow-y-auto;
  transition: 0.5s;
}
</style>
